<div class="row step-header">
  <div class="col mb0 col-100">
    <div class="questionmark centered mb2"> </div>
    <h3>Uh-oh, something went wrong.</h3>
    <p class="mb2">We’ve created your account, but were unable to schedule your installation.</p>
    <p class="mb0">Please call us at <a class="text-link" href="tel:+8882319403">888.231.9403</a> to complete your signup. Our humans are standing by.</p>
  </div>
</div>
